import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import AuthService from '../../../state/auth.service';
import GroupApi from '../../../api/group';

import Logo from '../../logo';
import LoginForm from './LoginForm';

import { Redirect } from 'react-router-dom';

class LoginPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
        };
    }
    componentDidMount() {
        const user = AuthService.getUser();
        if (user) {
            const groupId = AuthService.getUser().group_id;
            GroupApi.getEvents(groupId)
                .then(e => {
                    // go to dashboard
                    this.setState({ redirect: true });
                })
                .catch(e => {
                    console.log('Unauthorized!');
                });
        }
    }
    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect to="./consultant/dashboard" />;
        }
    };
    render() {
        return (
            <div className="LoginPage">
                {this.renderRedirect()}

                <div className="LoginPage__logo">
                    <Logo />
                </div>
                <div className="LoginPage__form">
                    <h2>Welcome!</h2>
                    <p>Sign in to access your PCMH project and account.</p>
                    <LoginForm />
                    <p>
                        <strong>Forgot your password?</strong>
                        <Link to="/account/reset"> Request to reset it.</Link>
                    </p>
                </div>
            </div>
        );
    }
}

export default LoginPage;
